import { useGetProductBatchDetails } from "../../../../../hooks/api/queries";
import { useParams } from "react-router-dom";

const useEditProductBatch = () => {
  const { id } = useParams();
  const { isLoading, data: batchInfo } = useGetProductBatchDetails(id);
  return {
    isLoading,
    batchInfo,
  };
};

export default useEditProductBatch;
